import React, { useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import {
  Box,
  Paper,
  TextField,
  Button,
  Typography,
  Container,
  Alert,
  FormControlLabel,
  Checkbox,
  InputAdornment,
  IconButton,
} from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";
import CalculateIcon from "@mui/icons-material/Calculate";
import { useAuth } from "../../context/AuthContext";
import { Link, useNavigate } from "react-router-dom";
import config from "../../config/config.json";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { useEffect } from "react";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const { login } = useAuth();
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const { isAuthenticated , token} = useAuth();

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  useEffect(() => {
    // If already logged in, redirect user
    if (isAuthenticated) {
      try {
        const storedUser = JSON.parse(atob(token.split('.')[1])); // decode token payload
        console.log("Stored User:", storedUser);
        if (storedUser?.isAdmin) {
          navigate("/admin/manage-agent", { replace: true });
        } else {
          navigate(`/calculator/${storedUser.AgentId}`, { replace: true });
        }
      } catch (err) {
        console.error("Invalid token format");
        navigate("/login", { replace: true });
      }
    }
  }, [isAuthenticated, token, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    try {
      const response = await fetch(`${config.base_url}/api/auth/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email, password }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Login failed");
      }

      // Call the login function from AuthContext
      login(data.token);

      if(data.user.isAdmin){
        navigate("/admin/manage-agent");
      }else{
        navigate(`/calculator/${data.user.AgentId}`);
      }

      // Navigate to admin dashboard after successful login
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <>
      <Container
        component="main"
        maxWidth="xs"
        sx={{
          width: "100%",
          px: { xs: 1, sm: 4 }, // responsive horizontal padding
        }}
      >
        {/* Image Container */}
        <Box sx={{ mt: 6 }}>
          <img
            src="/assets/images/osa-logo.svg" // Replace with your image path
            alt="Logo"
            style={{
              maxWidth: "204px",
              height: "auto",
              display: "block",
              margin: "0 auto",
            }}
          />
        </Box>
        <Box
          sx={{
            marginTop: 2,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            mx: { xs: 4, sm: 0 }, // ⬅️ Horizontal margin: 8px on xs (mobile), 0 on sm+
          }}
        >
          <Paper
            elevation={3}
            sx={{
              padding: { xs: 3, sm: 4 },
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              width: "100%",
              borderRadius: 2,
            }}
          >
            <Typography
              component="h1"
              variant="h6"
              gutterBottom
              sx={{ color: "var(--text-primary)" }}
            >
              Login to Fee Calculator
            </Typography>

            {error && (
              <Alert
                severity="error"
                sx={{ width: "100%", mb: 2, mt: 2, boxSizing: "border-box" }}
              >
                {error}
              </Alert>
            )}

            <Box
              component="form"
              onSubmit={handleSubmit}
              sx={{ width: "100%" }}
            >
              <TextField
                className="input-field"
                margin="normal"
                required
                fullWidth
                id="email"
                label="Email Address"
                name="email"
                autoComplete="email"
                autoFocus
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <EmailIcon color="action"   sx={{color:"gray"}}/>
                    </InputAdornment>
                  ),
                }}
              />
              <TextField
                className="input-field"
                margin="normal"
                required
                fullWidth
                name="password"
                label="Password"
                type={showPassword ? "text" : "password"}
                id="password"
                autoComplete="current-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                        edge="end"
                        sx={{color:"gray !important"}}
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              {/* New Row: Remember me + Forgot password */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  mt: 1,
                }}
              >
                <FormControlLabel
                  control={<Checkbox value="remember" color="primary" />}
                  label="Remember me"
                />
                {/* <Link
                  component={RouterLink}
                  to="/forgot-password"
                  variant="body2"
                  className="forgot-link"
                >
                  Forgot password?
                </Link> */}
              </Box>
              <Button
                type="submit"
                fullWidth
                variant="contained"
                sx={{
                  mt: 3,
                  mb: 2,
                  background: "var(--primary)",
                  textTransform: "none",
                  fontWeight: "bold",
                  "&:hover": {
                    backgroundColor: "black",
                  },
                }}
              >
                Sign In
              </Button>
            </Box>
          </Paper>
        </Box>
      </Container>
    </>
  );
};

export default Login;
